// plugins/vuex-store.js
import { defineNuxtPlugin } from '#app';
import { createStore }     from 'vuex';

export default defineNuxtPlugin(async (nuxtApp) => {
    // 1. Grab every JS file in /stores at build time
    const modules = import.meta.glob('../stores/*.js', { eager: true });
    const vuexModules = {};

    // 2. Turn that map of { path: module } into { name: vuexModule }
    for (const path in modules) {
        const name = path.match(/\/([^\/]+)\.js$/)[1];   // e.g. 'userAuth'
        const mod  = modules[path];

        vuexModules[name] = {
            namespaced: true,
            state:      mod.state,
            getters:    mod.getters,
            mutations:  mod.mutations,
            actions:    mod.actions,
        };
    }

    // 3. Create & install your store
    const store = createStore({ modules: vuexModules });
    nuxtApp.vueApp.use(store);

    // 4. Make it available via `useNuxtApp().$vuex` or `inject('vuex')`
    nuxtApp.provide('vuex', store);
    nuxtApp.provide('auth', store.state.auth);
});
